export const UPDATE_ACCOUNT_NAME = 'UPDATE_NAME';
export const UPDATE_ACCOUNT_LOGGED_STATUS = 'UPDATE_ACCOUNT_LOGGED_STATUS';
export const REQUEST_USER_INFO = 'REQUEST_USER_INFO';
export const RECEIVE_USER_INFO = 'RECEIVE_USER_INFO';
export const UPDATE_CSAGENT_INFO = 'UPDATE_CSAGENT_INFO';
export const UPDATE_CSAGENT_LOGGED_STATUS = 'UPDATE_CSAGENT_LOGGED_STATUS';
